import APIV3 from '../axios/APIV3';

export const removeMapItem = async (payload) => {
    let result;
    result = await APIV3.patch(`/restaurants/:restaurantId/un-map-items-from-category`, payload);

    return result;
};
